<template>

  <div class="center-screen">

    <div class="marvel-device iphone5s silver">
      <div class="top-bar"></div>
      <div class="sleep"></div>
      <div class="volume"></div>
      <div class="camera"></div>
      <div class="sensor"></div>
      <div class="speaker"></div>
      <div class="screen">
        <iframe :src="'/' + id + '?embed=true' + route"
                frameborder="0"></iframe>

      </div>
      <div class="home"></div>
      <div class="bottom-bar"></div>
    </div>

    <!-- Accessibility Overlay - Only visible when NOT in Demo mode -->
    <AccessibilityOverlay 
      v-if="isDemo"
      :enabled="true"
      button-text="🔍 Check Game Colors"
      button-title="Analyze color contrast in game content"
      results-title="Game Color Contrast Analysis"
      iframe-selector="iframe"
      :game-configuration="gameConfiguration"
      :game-type="gameType"
    />

  </div>


</template>

<script>
import axios from 'axios';
import AccessibilityOverlay from '../components/controls/AccessibilityOverlay.vue';
import { pack, unpack } from '../utils/pack.js';

export default {
  components: {
    AccessibilityOverlay
  },
  data: function () {
    return {
      id: '',
      route: '',
      gameConfiguration: null,
      gameType: null,
      isLoadingConfiguration: false,
      isDemo: false
    }
  },

  async created() {
    this.id = this.$route.params.id;
    if (this.$route.query) {
      if (this.$route.query.validLocation === null)
        this.route = '&validLocation';
      else if (this.$route.query.invalidLocation === null)
        this.route = '&invalidLocation';
      else if (this.$route.query.multipleLocations === null)
        this.route = '&multipleLocations';
      if (this.$route.query.language != null)
        this.route += "&language=" + this.$route.query.language;
    }

    // Check if this is a demo and load game configuration only if not demo
    await this.checkDemoStatusAndLoadConfiguration();
  },

  methods: {
    async checkDemoStatusAndLoadConfiguration() {
      if (!this.id) return;

      this.isLoadingConfiguration = true;
      try {
        // Use the same API call pattern as Home.vue to check demo status
        let query = '';
        if (this.$route.query && this.$route.query.language) {
          query = '?language=' + this.$route.query.language;
        }

        const data = { code: this.id };
        const packedData = pack(data);

        const response = await axios.post(process.env.VUE_APP_API_URL + 'play-data' + query, {
          _data: packedData._data
        });

        const packedResult = response.data;
        const responseData = packedResult && packedResult._data ? unpack(packedResult) : packedResult;

        if (responseData.success) {
          this.isDemo = responseData.isDemo;
          
          // Load configuration for both demo and non-demo modes
          if (responseData.configuration) {
            this.gameConfiguration = responseData.configuration;
            this.gameType = responseData.configuration.type;
          }
        } else {
          console.warn('No valid response for game ID:', this.id);
        }
      } catch (error) {
        console.error('Failed to load game data:', error);
        // Don't show error to user, just log it
      } finally {
        this.isLoadingConfiguration = false;
      }
    }
  }
}

</script>

<style scoped>

@import '../assets/devices.min.css';

iframe {
  display: block;
  height: 100%;
  min-height: 100%;
  width: 100%;
  margin: 0;
}

.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
  background-color: black;
}


</style>
